export const documentUrl = (urlStr: string) => {
  try {
    const url = new URL(urlStr)
    if (process.env.NODE_ENV === 'development' && url.host.endsWith('jusbrasil.com.br')) {
      url.host = 'local.jusbrasil.com.br'
    }
    return url.toString()
  } catch {
    return urlStr
  }
}
